import {
  requests
} from '../../../api/agent'

export default {
  getSocialGroupTypes: (params) => requests.getWithParams('/ReSocialGroupTypes/ListAllPaged', params),
  getSocialGroupByName: (params) => requests.getWithParams('/ReSocialGroupTypes/getByName', params),
  createSocialGroupType: (params) => requests.post('/ReSocialGroupTypes/CreateSocialGroupType', params),
  deleteSocialGroupType: (params) => requests.post('/ReSocialGroupTypes/DeleteSocialGroupType', params),
  updateSocialGroupType: (params) => requests.post('/ReSocialGroupTypes/UpdateSocialGroupType', params),
  restoreSocialGroupType: (params) => requests.post('/ReSocialGroupTypes/RestoreSocialGroupType', params)
}